// Copyright (c) Docugami, Inc. All rights reserved.

import { Component, ComponentId } from "sdv/engine/Component";
import { Box } from "store/shared_types";

export enum GrabberType {
    Left,
    Right,
    Top,
    Bottom
}

export interface Grabber {
    bounds: Box;
    visual: Box;
    type: GrabberType;
}

export interface GrabberComponent extends Component {
    typeId: ComponentId.Grabber;
    grabber: Grabber;
}
